import React, { PureComponent } from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,linearGradient } from 'recharts';

const data = [
  {
    name: 'Jan',
    uv: 1000
    ,
  },
  {
    name: 'Feb',
    uv: 200,
  },
  {
    name: 'Mar',
    uv: 300,
  },
  {
    name: 'Apr',
    uv: 700,
  },
  {
    name: 'May',
    uv: 500,
  },
  {
    name: 'Jun',
    uv: 300,
  },
  {
    name: 'Jul',
    uv: 5000,
  },
  {
    name: 'Aug',
    uv: 2000,
   
  },
  {
    name: 'Sep',
    uv: 4000,
   
  },
  {
    name: 'Oct',
    uv: 3000,

  },
  {
    name: 'Nov',
    uv: 2000,
   
  },
  {
    name: 'Dec',
    uv: 1000,
  
  },
];

export default class Example extends PureComponent {
  // static demoUrl = 'https://codesandbox.io/s/simple-area-chart-4ujxw';
  // http://41.138.161.35:8084/api/Applicant/GetAllApplicantChart;
  constructor(props){
    super(props);
    this.props = props;
    
  }
 

  render() {
    return (
      <>
        {this.props && this.props.data &&
          <ResponsiveContainer width="100%" height="100%">
          <AreaChart
            width={500}
            height={400}
            data={this.props.data}
            margin={{
              top: 10,
              right: 30,
              left: 0,
              bottom: 0,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <defs>
              <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#21c475" stopOpacity={0.8}/>
                <stop offset="95%" stopColor="#21c475" stopOpacity={0}/>
              </linearGradient>
            </defs>
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Area type="monotone" dataKey="value" stroke="#21c475" fillOpacity={1} fill="url(#colorUv)" />
          </AreaChart>
        </ResponsiveContainer>
        }
      </>
      
    );
  }
}